import React, { useState, useEffect } from 'react';
import { Accordion } from './primitives';
import { IoClose } from "react-icons/io5";
import { useDatabase } from '../contexts/DatabaseContext';

export default function MasterErrorBar() {
    const [masterErrorList, setMasterErrorList] = useState([]);
    const [errorCounter, setErrorCounter] = useState(0);
    const { createErrorEvent } = useDatabase();
    
    useEffect(() => {
        const handleError = (event) => {
            const { detail, action, diabolical } = event;
            const errorObject = {
                id: `error-${Date.now()}-${errorCounter}`,
                code: detail?.code || null,
                message: typeof detail === 'string' 
                    ? detail 
                    : detail?.message || 'An unexpected error occurred.'
            };
            if (errorObject.message === 'Network Error') return;
            setErrorCounter(prev => prev + 1);
            setMasterErrorList(prevErrors => {
                const newErrors = [...prevErrors, errorObject];
                return newErrors.slice(-5);
            });
            createErrorEvent(errorObject.code, errorObject.message, action || null, diabolical || false);
        };
        
        window.addEventListener('masterError', handleError);
        return () => window.removeEventListener('masterError', handleError);
    }, []);

    if (masterErrorList.length === 0) {
        return null;
    }

    return (
        <div className="master-error-list">
            {masterErrorList.map((error) => (
                <div key={error.id} className="master-error-item">
                    <Accordion className="master-error-accordion">
                        <Accordion.Item>
                            <Accordion.Header style={{ height: '35px' }}>
                                {error.code ? `Error ${error.code}` : `Error`}
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="master-error-body">
                                    <div className="master-error-body-inner">
                                        <div>
                                            {error.message}
                                            <br /><br />
                                            <span style={{ fontWeight: '500' }}>Timestamp:</span> {new Date().toLocaleTimeString()}
                                        </div>
                                        <IoClose className="master-error-close" onClick={() => setMasterErrorList(prev => prev.filter(item => item.id !== error.id))} />
                                    </div>
                                </div>
                                {/* Current functionality of this button is unclear.
                                    First suggestion: error code and message to clipboard so it can be
                                    pasted to us in a message quickly. */}
                                {/* <div style={{ display: 'flex', justifyContent: 'right' }}>
                                    <button className="master-error-button">
                                        Copy
                                    </button>
                                </div> */}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            ))}
        </div>
    );
}
